import type { ComponentProps } from 'react';

import * as TabsPrimitive from '@radix-ui/react-tabs';
import { cn } from '@repo/lib/cn';

export function Tabs(tabsProps: ComponentProps<typeof TabsPrimitive.Root>) {
  const { className, ...props } = tabsProps;
  return <TabsPrimitive.Root data-slot="tabs" className={cn(className)} {...props} />;
}

export function TabsList(tabsListProps: ComponentProps<typeof TabsPrimitive.List>) {
  const { className, ...props } = tabsListProps;
  return <TabsPrimitive.List data-slot="tabs-list" className={cn('bg-muted inline-flex h-fit w-fit items-center justify-center rounded-md p-1', className)} {...props} />;
}

export function TabsTrigger(tabsTriggerProps: ComponentProps<typeof TabsPrimitive.Trigger>) {
  const { className, ...props } = tabsTriggerProps;
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
        'text-md text-muted-foreground animate-in fade-in outline-focus-ring disabled:text-muted-foreground/60 data-[state=active]:bg-background data-[state=active]:text-foreground relative inline-flex h-8 cursor-pointer items-center justify-center gap-2 overflow-hidden rounded-sm px-4 font-medium whitespace-nowrap opacity-100 outline-0 transition-all duration-300 ease-out focus-visible:outline-3 disabled:pointer-events-none disabled:cursor-not-allowed data-[state=active]:shadow-sm [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
        className
      )}
      {...props}
    />
  );
}

export function TabsContent(tabsContentProps: ComponentProps<typeof TabsPrimitive.Content>) {
  const { className, ...props } = tabsContentProps;
  return <TabsPrimitive.Content data-slot="tabs-content" className={cn('animate-in fade-in flex-1 duration-300 outline-none', className)} {...props} />;
}
